module.exports = "<dskl-menu [items]=\"desks\" [up]=\"up\" [label]=\"'DESCS_MENU.SELECT_BOARD_TYPE' | translate\" (selected)=\"onSelected($event,0 )\" [item]=\"currentItem\"></dskl-menu>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/desksmenu/desks-menu.component.html
// module id = ../../../../../src/app/wb/desksmenu/desks-menu.component.html
// module chunks = main